module.exports = __webpack_public_path__ + "img/bg1024.9f03a31f.png";